import React from "react";

export default (props) =>
    <label className="text-gray-500 pb-1 inline-block text-sm" htmlFor={ props.id }>
        { props.label }
    </label>